import { API_URLS } from "../../../../Configs/apiUrls";
import axiosInstance from "../../../../Configs/axios";

export const profileFn = (redBody) => {
  try {
    const response = axiosInstance.get(API_URLS.profile, redBody);
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};
